export default __webpack_public_path__ + "static/media/pic11.0d15857a.jpg";